import { Component, ElementRef, input, output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { JumpTextEntity } from '@xmedical/core';
import { XmedicalUiModule } from '@xmedical/ui';

@Component({
  selector: 'xmed-jump-text-renderer',
  standalone: true,
  imports: [
    FormsModule,
    XmedicalUiModule
  ],
  templateUrl: './jump-text-renderer.component.html',
  styleUrl: './jump-text-renderer.component.scss'
})
export class JumpTextRendererComponent {
  @ViewChild('templateEditor') editor!: ElementRef;

  backgroundColor = input<string>('');
  value = input<string>('');
  template = input<JumpTextEntity | null>(null);
  rows = input<number>(5);

  valueChanges = output<string>();

  // Local value for two-way binding
  localValue = '';

  ngOnInit(): void {
    this.localValue = this.value();
  }

  keyupHandler(event: Event): void {
    this.valueChanges.emit(this.localValue);
  }

  pasteHandler(event: Event): void {
    this.valueChanges.emit(this.localValue);
  }
}
